import LoadingButton from '@mui/lab/LoadingButton';
import {
    Alert,
    Checkbox,
    Container,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';

import {useFormik} from 'formik';
import {useSnackbar} from 'notistack';
import {useEffect, useState} from 'react';
import server from '../../../global/server';
import useHandleErrors from '../../../hooks/useHandleErrors';

import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../../context/AuthContext';
import SelectTeam from '../../../components/SelectTeam';

export default ({data, mutate, close}) => {
    const {user} = useAuth();
    const navigation = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        handleBlur,
        handleReset,
        setValues,
        isSubmitting,
    } = useFormik({
        initialValues: {
            name: '',
            team_id: '',
            status: true,
            createdAt: '',
        },
        onSubmit: async (values, {setSubmitting}) => {
            try {
                setSubmitting(true);
                if (Boolean(data?.id)) {
                    await server.put(`person`, values);
                    enqueueSnackbar('Dados alterados');
                    mutate();
                } else {
                    const response = await server.post(`person`, values);
                    enqueueSnackbar('Dados inseridos');
                    
                }                
                
                close();
                setSubmitting(false);
            } catch (error) {
                console.log(error.response);
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const {team_id, status, name, id} = data;
            setValues({team_id, status, name, id}, false);
        }
    }, [data]);

    return (
        <>
            <Container fixed sx={{my: 3}}>
                <Grid container spacing={2}>
                    {/* {Boolean(data?.id) && (
                        <Grid item xs={12}>
                            <Stack alignItems="flex-end">
                                <Alert>Cadastrado desde {new Date(values.createdAt).toLocaleString('pt-BR')}</Alert>
                            </Stack>
                        </Grid>
                    )}
                    <Grid item xs={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Nome"
                            type="text"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            error={errors.name}
                            helperText={errors.name}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Login"
                            type="text"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            error={errors.name}
                            helperText={errors.name}
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Documento"
                            type="text"
                            name="document"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.document}
                            error={errors.document}
                            helperText={errors.document}
                        />
                    </Grid> */}
                    {/* <SelectTeam
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        error={errors.team_id}
                        value={values.team_id}
                        name="team_id"
                        disabled={Boolean(data) && data?.id === user?.id}
                    /> */}

                    {/* <Grid item xs={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Telefone"
                            type="text"
                            name="cellphone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.cellphone}
                            error={errors.cellphone}
                            helperText={errors.cellphone}
                        />
                    </Grid> */}

                    {/* <Grid item xs={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Email"
                            type="email"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            error={errors.email}
                            helperText={errors.email}
                        />
                    </Grid> */}

                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Senha"
                            type="password"
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            error={errors.password}
                            helperText={errors.password}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={values.status}
                                        disabled={data?.id === user?.id}
                                        onChange={handleChange}
                                        name="status"
                                        inputProps={{
                                            'aria-controls': 'controlled',
                                        }}
                                    />
                                }
                                label={values.status ? 'Ativo' : 'Inativo'}
                            />
                        </FormGroup>
                    </Grid>
                    <Divider />
                    <Grid
                        container
                        item
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center">
                        <Grid>
                            <LoadingButton
                                variant="contained"
                                loading={isSubmitting}
                                onClick={handleSubmit}>
                                Salvar dados
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};
